import { render, staticRenderFns } from "./JobAdvantage.vue?vue&type=template&id=8e7674f0&scoped=true"
import script from "./JobAdvantage.vue?vue&type=script&lang=js"
export * from "./JobAdvantage.vue?vue&type=script&lang=js"
import style0 from "./JobAdvantage.vue?vue&type=style&index=0&id=8e7674f0&prod&scoped=true&lang=css"
import style1 from "../../constant/css/detail.css?vue&type=style&index=1&id=8e7674f0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7674f0",
  null
  
)

export default component.exports